import React, { createContext, Component  } from 'react';
import pathSettings from './urlSettings.json';

export const StateAmbContext = createContext();

class StateAmbContextProvider extends Component{
    state = {
        stateAmb:{
            w:6,
            h: 8,
            l: 6,
            saved: false,
            roomtemp: 35,
            application: "Cooler",
            typical_btuh: 0,
            heavy_btuh: 0,
            boxloaded: false,
            selected_option : "typical",
            room_area: 0,
            room_vol: 0
        },
        settings:{},
        image_settings:{}
    };

    componentDidMount(){
        const res = fetch(pathSettings.settings_path,{
            headers : { 
              'Content-Type': 'application/json',
              'Accept': 'application/json'
             }
          }).then(async(response)=>{
            const data = await response.json();
            this.setState({settings:data})
          })  
        const resImg = fetch(pathSettings.imageSettings_path,{
            headers : { 
              'Content-Type': 'application/json',
              'Accept': 'application/json'
             }
          }).then(async(responseImg)=>{
            const dataresImg = await responseImg.json();
            this.setState({image_settings:dataresImg})
          })  
    }
    updateStateAmb = (holdState)=>{
        this.setState({stateAmb:holdState});
    }
    render (){
        return(
            <StateAmbContext.Provider value={{stateAmb:{...this.state.stateAmb},settings:{...this.state.settings}, image_settings:{...this.state.image_settings} ,updateStateAmb:this.updateStateAmb}}>
                { this.props.children }
            </StateAmbContext.Provider>

        )
    }
}
export default StateAmbContextProvider;